import { andUpTextMapping } from './andUpTextMapping.js';

/**
 * @description Gets localized "and Up" text template string based on provided locale
 * @param {string} locale "xx-YY" formatted locale string
 * @returns {string} Localized "and Up" text template string
 */
export const getAndUpText = (locale) => {
  let andUpText;
  const locales = Object.keys(andUpTextMapping);
  const languageCode = locale.split('-', 2)[0];

  if (locales.includes(locale)) andUpText = andUpTextMapping[locale];
  else if (locales.includes(languageCode)) andUpText = andUpTextMapping[languageCode];
  else andUpText = '{0} and up';

  return andUpText;
};

export default getAndUpText;
